import _ from 'lodash';

export default {
    filters: state => {
        return state.filters;
    },

    selectedFilters: state => {
        return state.selectedFilters;
    },

    appliedFilters: state => {
        let filters = _.cloneDeep(state.selectedFilters);

        for( let filter in filters ) {
            let value = filters[filter];

            switch(filter) {
                case 'boughtClicksGte':
                case 'soldClicksGte':
                    value = parseInt(value);
                    if( _.isNaN(value) ) {
                        value = undefined
                    } else if( value <= 0 ) {
                        value = undefined
                    }
                    break;

                case 'profitGte':     
                    value = parseFloat(value);
                    if( _.isNaN(value) ) value = undefined;
                    break;

                case 'campaignName': 
                case 'adGroupName': 
                case 'searchPhrase':
                    value = _.isString(value) && value.length > 0 ? value : undefined;
                    break;

                case 'opCtrInRange':
                case 'rpcInRange':
                    value = _.map(value, v => {
                        v = parseFloat(v);
                        if( _.isNaN(v) ) v = null;
                        return v;
                    });
                    if( _.some(value, v => v === null) ) {
                        value = undefined;
                    }
                    
                default:
                    if( _.isArray(value) && value.length == 0 ) value = undefined;
                    break;
            }

            if( value === undefined ) {
                _.unset(filters, filter);
            } else {
                filters[filter] = value;
            }
        }  
        
        return filters;
    },

    report: state => {
        return state.report;
    },

    dailyReport: state => {
        return state.dailyReport;
    },

    selectedColumns: state => {
        return state.selectedColumns;
    },

    fixedColumns: state => {
        return state.fixedColumns;
    },

    sortedColumns: state => {
        return state.sortedColumns;
    },

    limit : state => {
        return state.limit;
    },

    direction: state => {
        return state.direction;
    },

    cursor: state => {
        return state.cursor;
    },

    pageInfo: state => {
        if( _.isObject(state.report.pageInfo) ) {
            return state.report.pageInfo;
        }
        return {};
    }    
}


// WEBPACK FOOTER //
// ./src/store/modules/adgroupReport2/getters.js